var FromLabelStyle = function(theme) {
    var flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return {
        container: {
            default: {
                position: 'relative'
            },
            accessibleOnly: {
                position: 'absolute',
                left: '-100000px',
                top: 'auto',
                width: '1px',
                height: '1px',
                overflow: 'hidden'
            }
        },
        label: {
            default: {
                fontFamily: theme.font.base.family,
                fontStyle: 'normal',
                fontWeight: theme.font.base.weight.regular,
                letterSpacing: 'normal',
                lineHeight: theme.font.lineHeight.base,
                textIndent: 0,
                textShadow: 'none',
                textTransform: 'none',
                color: theme.font.color.soft,
                display: 'block',
                fontSize: theme.font.base.size[3],
                margin: '0 0 0.25rem',
                padding: 0,
                verticalAlign: 'top'
            },
            textDirection: {
                rtl: {
                    textAlign: 'right'
                },
                ltr: {
                    textAlign: 'left'
                }
            }
        },
        requiredIndicatorContainer: {
            default: {
                fontFamily: theme.font.base.family,
                fontStyle: 'normal',
                fontWeight: (flags === null || flags === void 0 ? void 0 : flags.typographyUpdates) ? theme.font.base.weight.regular : theme.font.base.weight.light,
                letterSpacing: 'normal',
                lineHeight: theme.font.lineHeight.base,
                textIndent: 0,
                textShadow: 'none',
                textTransform: 'none',
                position: 'absolute',
                color: theme.font.color.danger.base,
                fontSize: theme.font.base.size.l
            },
            textDirection: {
                rtl: {
                    right: '-11px',
                    textAlign: 'right'
                },
                ltr: {
                    left: '-11px',
                    textAlign: 'left'
                }
            }
        }
    };
};
export default FromLabelStyle;
